import { defineComponent as _defineComponent } from 'vue'
import FieldNote from 'JS/components/FieldNote.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyNotice',
  props: {
    privacyControlsEnabled: { type: Boolean },
    gpcSignalDetected: { type: Boolean },
    optedOutOfTrackingCookies: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	privacyControlsEnabled: boolean;
	gpcSignalDetected: boolean;
	optedOutOfTrackingCookies: boolean;
}


const showErrorMessage = ref<boolean>(false);

function handleOptOutRequest() {
	if (props.privacyControlsEnabled) {
		//@ts-ignore
		performBannerAction('reject');
	} else {
		showErrorMessage.value = true;
	}
}



return { __sfc: true,props, showErrorMessage, handleOptOutRequest, FieldNote }
}

})